import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutInvoiceProcessingProfileList extends Layout {
    layoutheaderInvoiceProcessingProfileList: LayoutHeader;
    sourceInvoiceProcessingProfile: DataSource;
    tableSearch: Table;
}
